import React, {Component} from "react"
import {LazyLoad} from "@irati/utils/history/routing"
import domain from "@irati/utils/env/domain"

export default class Routes extends Component {
  render() {
    if (domain.isDev()) {
      return <LazyLoad routes={() => import(/* webpackChunkName: "devTools" */ "./devTools")} />
    }
    if (domain.isCanvaRedirect()) {
      return <LazyLoad routes={() => import(/* webpackChunkName: "canvaRedirect" */ "./canvaRedirect")} />
    }
    if (domain.isInternal()) {
      return <LazyLoad routes={() => import(/* webpackChunkName: "internal" */ "./internal")} />
    }
    if (domain.isGlobal()) {
      return <LazyLoad routes={() => import(/* webpackChunkName: "global" */ "./global")} />
    }

    return <LazyLoad routes={() => import(/* webpackChunkName: "tenant" */ "./tenant")} />
  }
}
